import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { BillsPaymentService } from "./BillPaymentService";

export const GetServiceType = createAsyncThunk(
    "ls/GetServiceType",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().GetServiceType(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const BuyAirtime = createAsyncThunk(
    "ls/BuyAirtime",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().BuyAirtime(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetDataPlans = createAsyncThunk(
    "ls/GetDataPlans",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().GetDataPlans(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const BuyData = createAsyncThunk(
    "ls/BuyData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await BillsPaymentService.BillsPaymentModule().BuyData(
                payload
            );
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const ValidateCustomer = createAsyncThunk(
    "ls/VerifyCustomer",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().ValidateCustomer(
                    payload
                );
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const CableTvPlans = createAsyncThunk(
    "ls/GetCablePlans",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().GetCablePlans(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const TvCablePay = createAsyncThunk(
    "ls/TvCablePay",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().TvCablePay(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const ElectricityPay = createAsyncThunk(
    "ls/ElectricityPay",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().ElectricityPay(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const BettingPay = createAsyncThunk(
    "ls/BettingPay",
    async (payload, { rejectWithValue }) => {
        try {
            const response =
                await BillsPaymentService.BillsPaymentModule().BettingPay(payload);
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
            return rejectWithValue(error?.response?.data);
        }
    }
);

const initialState = {
    loading: false,
    GetServiceTypeSuccess: null,
    BuyAirtimeSuccess: null,
    GetPlansSuccess: null,
    BuyDataSuccess: null,
    CableTvPlans: null,
    ValidatedCustomer: null,
    TvCablePay: null,
    ElectricityPay: null,
    BettingPaySuccess: null,
    validating: false,
};

export const BillsPaymentSlice = createSlice({
    name: "billspayment",
    initialState,
    reducers: {
        resetElectricityPay: (state) => {
            state.ElectricityPay = null;
        },
        resetPayState: (state, action) => {
            state[action.payload] = null;
        },
    },
    extraReducers: {
        [GetServiceType.pending]: (state) => {
            state.loading = true;
        },

        [GetServiceType.fulfilled]: (state, action) => {
            return {
                ...state,
                GetServiceTypeSuccess: action.payload,
                loading: false,
            };
        },

        [GetServiceType.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                GetServiceTypeSuccess: action.payload,
            };
        },

        [BuyAirtime.pending]: (state) => {
            state.loading = true;
        },

        [BuyAirtime.fulfilled]: (state, action) => {
            return {
                ...state,
                BuyAirtimeSuccess: action.payload,
                loading: false,
            };
        },

        [BuyAirtime.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                BuyAirtimeSuccess: action.payload,
            };
        },
        [GetDataPlans.pending]: (state) => {
            state.loading = true;
        },

        [GetDataPlans.fulfilled]: (state, action) => {
            return {
                ...state,
                GetPlansSuccess: action.payload,
                loading: false,
            };
        },

        [GetDataPlans.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                GetPlansSuccess: action.payload,
            };
        },
        [BuyData.pending]: (state) => {
            state.loading = true;
        },

        [BuyData.fulfilled]: (state, action) => {
            return {
                ...state,
                BuyDataSuccess: action.payload,
                loading: false,
            };
        },

        [BuyData.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                BuyDataSuccess: action.payload,
            };
        },
        [ValidateCustomer.pending]: (state) => {
            state.validating = true;
        },

        [ValidateCustomer.fulfilled]: (state, action) => {
            return {
                ...state,
                ValidatedCustomer: action.payload,
                validating: false,
            };
        },

        [ValidateCustomer.rejected]: (state, action) => {
            return {
                ...state,
                validating: false,
                ValidatedCustomer: action.payload,
            };
        },
        [CableTvPlans.pending]: (state) => {
            state.loading = true;
        },

        [CableTvPlans.fulfilled]: (state, action) => {
            return {
                ...state,
                CableTvPlans: action.payload,
                loading: false,
            };
        },

        [CableTvPlans.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                CableTvPlans: action.payload,
            };
        },
        [TvCablePay.pending]: (state) => {
            state.loading = true;
        },

        [TvCablePay.fulfilled]: (state, action) => {
            return {
                ...state,
                TvCablePay: action.payload,
                loading: false,
            };
        },

        [TvCablePay.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                TvCablePay: action.payload,
            };
        },
        [ElectricityPay.pending]: (state) => {
            state.loading = true;
        },

        [ElectricityPay.fulfilled]: (state, action) => {
            return {
                ...state,
                ElectricityPay: action.payload,
                loading: false,
            };
        },

        [ElectricityPay.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                ElectricityPay: action.payload,
            };
        },
        [BettingPay.pending]: (state) => {
            state.loading = true;
        },

        [BettingPay.fulfilled]: (state, action) => {
            return {
                ...state,
                BettingPaySuccess: action.payload,
                loading: false,
            };
        },

        [BettingPay.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                BettingPaySuccess: action.payload,
            };
        },
    },
});

export const { resetElectricityPay, resetPayState } = BillsPaymentSlice.actions;
export default BillsPaymentSlice.reducer;
